<template>
	<div>
		<canvas v-if="show"
            ref="chartCanvas" 
            style="width:100%; height:100%;">
        </canvas>
	</div>
</template>

<script>
    export default {
        props: {
                points: { default: null },
                data:{ default: null},
                colorShadow: { default: 'rgba(0, 0, 0, 0.1)' },
                plotShadow: { default: false },
                margin: { default: () => {
                        return { top: 0, right: 0, bottom: 0, left: 0 } ;
                    }
                },
                fixedWidth: { default: 0 },
                fixedHeight: { default: 0 },
                smooth: { default: true }
            },
        data() {
            return {
                width: 300,
                height: 300,
                show:true,
                color: '#00ffd0',
            };
        },
        computed: {
        },
        methods: {
            makePath(points) {
                if (!points || points.length < 2) return;

                let canvasObj = this.$refs.chartCanvas;
                let sz = this.getResultedSize(canvasObj);
                this.width = sz[0];
                this.height = sz[1];

                let coords = this.scalePoints(points);
                var canvas = canvasObj.getContext("2d");
                canvas.clearRect(0, 0, this.width, this.height);
                // fill
                var fillGradient = canvas.createLinearGradient(0, 0, 0, this.height);
                fillGradient.addColorStop(0, "rgba(0, 222, 170, 0.41)");
                fillGradient.addColorStop(1, "rgba(0, 255, 220, 0)");

                canvas.beginPath();
                canvas.fillStyle = fillGradient;
                this.buildCurve(coords, canvas, this.width, this.height, true);                
                canvas.fill();
                
                // curve
                canvas.beginPath();
                this.buildCurve(coords, canvas);
                canvas.strokeStyle = this.color;
                canvas.lineWidth = 2;
                canvas.stroke();

                if (this.plotShadow) {
                    let shadowDelta = 4;
                    for (let i = 0; i < coords.length; i++) {
                        coords[i].x += shadowDelta;
                        coords[i].y += shadowDelta;
                    }
                    canvas.beginPath();
                    this.buildCurve(coords, canvas);
                    canvas.strokeStyle = this.colorShadow;
                    canvas.lineWidth = 3;
                    canvas.stroke();
                }
            },
            scalePoints(points) {
                //console.log(JSON.stringify({
                //    margin: this.margin,
                //    width: this.width,
                //    height: this.height
                //}));
                let min = points[0], max = points[0];
                for (let i = 1; i < points.length; i++) {
                    if (points[i] < min) min = points[i];
                    if (points[i] > max) max = points[i];
                }
                let range = max - min;
                let k = range == 0 ? 0 : (this.height - this.margin.top - this.margin.bottom) / range;
                let w = this.width - this.margin.left - this.margin.right;
                let screenCoords = [];
                for (let i = 0; i < points.length; i++) {
                    let x = i * w * 1. / (points.length - 1) + this.margin.left;
                    let y = this.height - this.margin.bottom - (points[i] - min) * k;
                    screenCoords.push({ x: x, y: y });
                }
                return screenCoords;
            },
            buildCurve(coords, canvas, closeCurve) {
                if (this.smooth)
                    this.buildSmoothCurve(coords, canvas, closeCurve);
                else
                    this.buildLineCurve(coords, canvas, closeCurve);
            },
            buildLineCurve(coords, canvas, closeCurve) {
                let w = this.width, h = this.height;
                canvas.moveTo(coords[0].x, coords[0].y);
                let i = 1;
                for (; i < coords.length; i++)
                    canvas.lineTo(coords[i].x, coords[i].y);
                if (closeCurve) {
                    canvas.lineTo(coords[i - 1].x, h - this.margin.bottom);
                    canvas.lineTo(this.margin.left, h - this.margin.bottom);
                    canvas.lineTo(this.margin.left, coords[0].y);
                }
            },
            buildSmoothCurve(coords, canvas, closeCurve) {
                let w = this.width, h = this.height;
                canvas.moveTo(coords[0].x, coords[0].y);
                let i = 1;
                for (; i < coords.length - 2; i ++) {
                    var xc = (coords[i].x + coords[i + 1].x) / 2;
                    var yc = (coords[i].y + coords[i + 1].y) / 2;
                    canvas.quadraticCurveTo(coords[i].x, coords[i].y, xc, yc);
                }
                // curve through the last two points
                canvas.quadraticCurveTo(coords[i].x, coords[i].y, coords[i+1].x, coords[i+1].y);
                if (closeCurve) {
                    canvas.lineTo(coords[i + 1].x, h - this.margin.bottom);
                    canvas.lineTo(this.margin.left, h - this.margin.bottom);
                    canvas.lineTo(this.margin.left, coords[0].y);
                }
            },
            fitToContainer(canvas) {
                if (!this.fixedWidth || !this.fixedHeight) {
                    canvas.style.width ='100%';
                    canvas.style.height='100%';
                    canvas.width  = canvas.offsetWidth;
                    canvas.height = canvas.offsetHeight;
                    return;
                }
                canvas.width = this.fixedWidth * window.devicePixelRatio;
                canvas.height = this.fixedHeight * window.devicePixelRatio;
                canvas.style.width = `${this.fixedWidth}px`;
                canvas.style.height = `${this.fixedHeight}px`;
                if(window.devicePixelRatio > 1)
                {
                let context = canvas.getContext('2d');
                context.scale(window.devicePixelRatio,window.devicePixelRatio);
                }
            },
            getResultedSize(canvas) {
                if (!this.fixedWidth || !this.fixedHeight)
                    return [ canvas.clientWidth, canvas.clientHeight ];
                return [ this.fixedWidth, this.fixedHeight ];
            }
        },
        watch: {
            points: function() {
                this.makePath(this.points);
            },
            data: function(newData, oldData) {
                newData < oldData ? this.color = "#ff9292" : this.color = '#00ffd0';
                this.makePath(this.points);
            },
            fixedWidth: function() {
                this.makePath(this.points);
            }
        },
        mounted() {
            this.fitToContainer(this.$refs.chartCanvas);
            if (this.points)
                this.makePath(this.points);
        }
    };    
</script>